import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, AuthService, UtilityService } from 'app/core/core.module';
import { Committee, CommitteeAttachment, CommitteeAttachmentReview, CommitteeMember } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { environment } from 'environments/environment';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { MinutesEmailDialogComponent } from '../minutes-email-dialog/minutes-email-dialog.component';
import { DocumentService } from 'app/core/data/document.service';
import { Subject } from 'rxjs';
import { EmailDialogComponent } from 'app/shared/email-dialog/email-dialog.component';

@Component({
    selector: 'app-minutes-overview',
    templateUrl: './minutes-overview.component.html',
    styleUrls: ['./minutes-overview.component.scss'],
    standalone: false,
})
export class MinutesOverviewComponent implements OnInit {
    documents: CommitteeAttachment[] = [];
    showAsDialog = false;
    reviews: any = [];
    serviceName = environment.serviceName;
    uploadHeaders: any;
    years: number[];
    selectedYear: number;
    months = [
        { id: 1, name: 'January' },
        { id: 2, name: 'February' },
        { id: 3, name: 'March' },
        { id: 4, name: 'April' },
        { id: 5, name: 'May' },
        { id: 6, name: 'June' },
        { id: 7, name: 'July' },
        { id: 8, name: 'August' },
        { id: 9, name: 'September' },
        { id: 10, name: 'October' },
        { id: 11, name: 'November' },
        { id: 12, name: 'December' },
    ];
    selectedMonthId: number;
    isClerk = false;
    isAdmin = false;
    isMinutesReviewer = false;

    committees: any;
    committeeId: number;
    executiveMembers: any;
    processing = false;
    mobile = false;
    mode: string;
    showAll: boolean = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        public auth: AuthService,
        private uow: ArkUnitOfWork,
        private modalService: BsModalService,
        public appInfo: AppInformationService,
        private utility: UtilityService,
        private docService: DocumentService
    ) {}

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
        if (window.innerWidth <= 900) {
            this.mobile = true;
        } else this.mobile = false;
    }

    async ngOnInit() {
        if (window.innerWidth <= 900) this.mobile = true;
        const today = new Date();
        this.years = _.sortBy(this.uow.lookups.givingYears);
        this.selectedYear = today.getFullYear();
        this.selectedMonthId = today.getMonth() + 1;

        this.uploadHeaders = { Authorization: 'Bearer ' + this.auth.currentUser.jwtToken };

        this.committees = this.uow.lookups.committees;
        this.committeeId = Committee.Committees.ExecutiveCommittee;
        this.executiveMembers = (await this.uow.getMembersByCommitteeIds([Committee.Committees.ExecutiveCommittee])) as CommitteeMember[];
        this.isClerk = this.auth.hasRole('Executive:Clerk');
        this.isAdmin = this.auth.hasRole('Administrator') || this.auth.hasRole('Executive:Admin');
        this.isMinutesReviewer = this.auth.hasRole('Executive:Clerk');
        await this.getData();
    }

    async toggleShowAll() {
        this.showAll = !this.showAll;
        this.appInfo.pleaseWaitShow();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.documents = (await this.uow.getCommitteeAttachments(this.committeeId)) as any[];
        if (!this.showAsDialog) {
            const reviews = (await this.uow.getCommitteeAttachmentReviews(this.auth.currentUser.personId, this.showAll)) as any[];

            for (const doc of this.documents) {
                const match = _.find(reviews, { committeeAttachmentId: doc.id });
                if (match) {
                    (doc as any).viewed = match.viewed;
                    (doc as any).dismissed = match.dismissed;
                }
            }
            console.log(reviews);
            if (this.isMinutesReviewer) {
                const overviews = (await this.uow.getMinutesReview()) as any[];
                (reviews as any[]).forEach((review) => {

                    const match = _.find(overviews, { id: review.committeeAttachmentId });
                    if (match) {
                        review.viewedCount = match.viewed;
                        review.unReadCount = match.unRead;
                        let readersArray = [];
                        let nonReadersArray = [];
                        match.readers.forEach((readers) => {
                            readersArray.push(`<span class=" small-font">${readers.name}</span>`);
                        });
                        match.nonReaders.forEach((readers) => {
                            nonReadersArray.push(`<span class=" small-font">${readers.name}</span>`);
                        });
                        review.readersHtml = `${readersArray.join(' - ')}`;
                        review.nonReadersHtml = `${nonReadersArray.join(' - ')}`;
                    }
                });
            }
            this.reviews = reviews;
        }

        this.appInfo.pleaseWaitHide();
    }

    onSelectionChanged(e) {
        const rows = this.dataGrid.instance.getSelectedRowsData();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            }
        );
    }

    rowDoubleClick(e) {
        this.openAttachment(e.data);
    }

    attachmentDoubleClick(e) {
        this.openAttachment(e.data);
    }

    view() {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;
        this.openAttachment(selectedRow);
    }

    async openAttachment(review: CommitteeAttachment) {
        console.log(review);
        if (!review) return;
        window.open(review.filename, '_blank');
        // review.viewed = new Date();
        await this.uow.commit();
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            if (!e.data.viewed) {
                e.rowElement.className = e.rowElement.className + ' new-document';
            }
        }
    }

    async add(selectedRow?: any) {
        const modalRef = this.modalService.show(AttachmentDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // proposal: !!selectedRow ? selectedRow : null,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.getData();
            }
            modalRef.hide();
        });
    }

    async email(mode?: string) {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const attachmentIds = selectedRows.map((x) => {
            return x.committeeAttachmentId;
        });
        const email = this.uow.committeeAttachmentEmails.createEntity({
            committeeId: this.committeeId,
            created: new Date(),
            createdBy: this.auth.currentUser.userName,
        });

        let attachmentArray = [];
        selectedRows.forEach((row) => {
            const attachmentLink = this.uow.committeeAttachmentEmailLinks.createEntity({
                emailId: email.id,
                attachmentId: row.committeeAttachmentId,
            });
            attachmentArray.push(row.name);
        });

        const modalRef = this.modalService.show(MinutesEmailDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                attachmentArray: attachmentArray,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (!!result && result.value) {
                email.committeeId = result.value;
                this.appInfo.pleaseWaitShow();
                await this.uow.commit();
                await this.utility.emailAgendaDocumentPackage(null, email.id, result.memberIds);
                this.appInfo.pleaseWaitHide();
                const status = alert(`${result.sendAsText ? 'Text' : 'Email'} Sent!`, `${this.appInfo.settings.church.toUpperCase()}`);
            }
            modalRef.hide();
            this.processing = false;
            await this.getData();
        });
    }

    async emailNew(mode?: string) {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const members = await this.uow.getMembersByCommitteeId(Committee.Committees.ExecutiveCommittee);

        const emailMessage = this.uow.committeeAttachmentEmails.createEntity({
            committeeId: Committee.Committees.ExecutiveCommittee,
            created: new Date(),
            createdBy: this.auth.currentUser.userName,
        });

        let attachmentArray = [];
        selectedRows.forEach((row) => {
            attachmentArray.push({id: row.id, name: row.name});
        });

        const modalRef = this.modalService.show(EmailDialogComponent, {
            class: 'modal-lgw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // entity: selectedRows,
                emailMessage: emailMessage,
                selectedCommitteeId: Committee.Committees.ExecutiveCommittee,
                members: members,
                subject: `Graafschap Documents`,
                body: `Please see the attached file(s).`,
                mode: 'executive',
                attachments: attachmentArray,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (!!result && result.value) {
                this.appInfo.pleaseWaitShow();
                await this.uow.commit();
                    await this.utility.emailAgendaDocumentPackage(null, emailMessage.id, result.memberIds);
                this.appInfo.pleaseWaitHide();
                const status = alert(`Email Sent!`, `${this.appInfo.settings.church.toUpperCase()}`);
            } else if (!result) this.uow.rollback();
            modalRef.hide();
            this.processing = false;
            await this.getData();
        });
    }

    async markAsViewed() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;
        this.appInfo.pleaseWaitShow();
        selectedRows.forEach((row) => {
            const review = this.reviews.find((r) => r.committeeAttachmentId === row.id);
            if (review && !review.viewed) review.viewed = new Date();
            else {
                this.uow.committeeAttachmentReviews.createEntity({
                    committeeAttachmentId: row.id,
                    personId: this.auth.currentUser.personId,
                    viewed: new Date(),
                    created: new Date(),
                    createdBy: this.auth.currentUser.userName,
                });
                
            }
        });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
    async markAsNonViewed() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;
        this.appInfo.pleaseWaitShow();
        selectedRows.forEach((row) => {
            const review = this.reviews.find((r) => r.committeeAttachmentId === row.id);
            if (review) review.viewed = null;
        });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async dismiss() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;
        const today = new Date();
        this.appInfo.pleaseWaitShow();
        selectedRows.forEach((row) => {
            const review = this.reviews.find((r) => r.committeeAttachmentId === row.id);
            if (review) review.dismissed = today;
        });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async delete() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        const result = await confirm(`Are you sure you want to delete?`, `GRRAFSCHAP`);
        if (!result) return;

        this.appInfo.pleaseWaitShow();
        const ids = selectedRows.map((x) => {
            return x.id;
        });
        await this.docService.deleteDocuments(ids);
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async uploadStarted(e) {
        this.appInfo.pleaseWaitShow();
    }

    async uploaded(e) {
        if (e && e.request && e.request.responseText) {
            const fileResponses = JSON.parse(e.request.responseText);
            const attachment = this.uow.committeeAttachments.createEntity({
                name: fileResponses.name,
                filename: fileResponses.link,
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
                committeeId: this.committeeId,
                typeId: 2,
            }) as CommitteeAttachment;

            // this.executiveMembers.forEach((person) => {
            //     this.uow.committeeAttachmentReviews.createEntity({
            //         committeeAttachmentId: attachment.id,
            //         personId: person.personId,
            //         created: new Date(),
            //         createdBy: this.auth.currentUser.userName,
            //     });
            // });
        }
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async uploadError(e) {
        await alert('An error occurred while attempting to upload the file(s)', `${this.appInfo.settings.church}`);
        this.appInfo.pleaseWaitHide();
    }

    async rename() {
        const modalRef = this.modalService.show(AttachmentDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                fileUploaded: true,
                attachment: this.dataGrid.instance.getSelectedRowsData()[0],
                renameOnly: true,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            } else {
                this.uow.rollback();
            }
            modalRef.hide();
        });
    }
}
